var _rect, _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-dc-tpl": 7,
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-dc-tpl": 8,
    x: 4,
    y: 8,
    width: 16,
    height: 11,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 9,
    d: "M12 8V5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-dc-tpl": 10,
    cx: 12,
    cy: 3.6,
    r: 1.3,
    fill: "currentColor",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-dc-tpl": 11,
    cx: 9.2,
    cy: 13.5,
    r: 1.25,
    fill: "currentColor",
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-dc-tpl": 12,
    cx: 14.8,
    cy: 13.5,
    r: 1.25,
    fill: "currentColor",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-dc-tpl": 13,
    d: "M2 12v3M22 12v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.5148088adc9412b726f368e5eb6b8e0f.svg";
export { ForwardRef as ReactComponent };